import { ActionIcon } from '@mantine/core';
import React from 'react';
import { FaPlay, FaStop } from 'react-icons/fa';
import { useGlobalAudioPlayer } from '../contexts/global_audio_player.context';

interface AudioPlayerProps {
  url?: string | null;
  title?: string;
  children?: React.ReactNode;
}

const AudioPlayer = ({ url, title = 'Audio playback' }: AudioPlayerProps) => {
  const { openAudio, closeAudio, currentUrl, isPlaying } = useGlobalAudioPlayer();
  const isDisabled = !url;
  const isCurrent = !!url && currentUrl === url;
  const showStop = isCurrent && isPlaying;

  return (
    <ActionIcon
      variant={isCurrent ? 'filled' : 'outline'}
      color={isCurrent ? 'blue' : 'gray.0'}
      size="lg"
      onClick={() => {
        if (!url) return;
        if (showStop) {
          closeAudio();
          return;
        }
        openAudio(url, title);
      }}
      disabled={isDisabled}
      title={showStop ? 'Stop and close global player' : 'Play in global player'}
    >
      {showStop ? <FaStop /> : <FaPlay />}
    </ActionIcon>
  );
};

export default AudioPlayer;